import { render, staticRenderFns } from "./IncDocPath.vue?vue&type=template&id=db11576e&"
import script from "./IncDocPath.vue?vue&type=script&lang=js&"
export * from "./IncDocPath.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports